// removed by extract-text-webpack-plugin
module.exports = {"content":"Benefits__content__hKhN4","text-box":"Benefits__text-box__2-9iz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Benefits/Benefits.scss
// module id = 369
// module chunks = 0